import { useHistory } from 'react-router-dom';

/** Shown when a free-plan student tries to track a third program. */
export default function UpgradeModal({ max, onClose }: { max: number; onClose: () => void }) {
  const history = useHistory();
  return (
    <div className="ep-modal-bg" role="dialog" aria-modal="true" aria-labelledby="ep-up-title" onClick={onClose}>
      <div className="ep-modal ep" style={{ padding: 24, minHeight: 0 }} onClick={(e) => e.stopPropagation()}>
        <h2 id="ep-up-title">Track more programs with Silver</h2>
        <p className="body" style={{ marginTop: 10, lineHeight: 1.55 }}>
          The free plan tracks {max} programs with a full checklist, reminders and calendar dates. Silver tracks as many as you like.
          You can still search and save programs on the free plan.
        </p>
        <div className="foot">
          <button type="button" className="btn primary" onClick={() => history.push('/payment')}>
            See plans
          </button>
          <button type="button" className="btn" onClick={onClose}>
            Not now
          </button>
        </div>
      </div>
    </div>
  );
}
